'use client'

import { useState } from 'react'
import styles from './CustomizerModal.module.css'
import ColorPalette from './ColorPalette/ColorPalette'
import BackendSelector from './BackendSelector/BackendSelector'
import { useModalStore } from '@/stores/useModalStore'

type Tab = 'palette' | 'backend' | 'other'

export default function CustomizerModal() {
  const { closeModal } = useModalStore()
  const [activeTab, setActiveTab] = useState<Tab>('palette')

  return (
    <div className={styles.customizerModalWrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>Personalizar Tema</h2>
        <button 
          className={styles.closeButton}
          onClick={closeModal}
          aria-label="Cerrar"
        >
          ✕
        </button>
      </div>

      <div className={styles.tabs}>
        <button 
          className={`${styles.tabButton} ${activeTab === 'palette' ? styles.active : ''}`}
          onClick={() => setActiveTab('palette')}
        >
          Color Palette
        </button>
        <button 
          className={`${styles.tabButton} ${activeTab === 'backend' ? styles.active : ''}`}
          onClick={() => setActiveTab('backend')}
        >
          Backend Selector
        </button>
        <button 
          className={`${styles.tabButton} ${activeTab === 'other' ? styles.active : ''}`}
          onClick={() => setActiveTab('other')}
        >
          Más Opciones (Próximamente)
        </button>
      </div>

      <div className={styles.content}>
        {activeTab === 'palette' && <ColorPalette />}
        {activeTab === 'backend' && <BackendSelector />}
        {activeTab === 'other' && (
          <div style={{ padding: '2rem', textAlign: 'center', color: '#a4a7ab' }}>
            Próximamente más opciones de personalización...
          </div>
        )}
      </div>
    </div>
  )
}
